import { createThirdwebClient } from "thirdweb";
 
export const client = createThirdwebClient({
  clientId: "6271a1af5b9faba1d5bcdf75b84e2bba",
});